import React, { useState, useRef, useEffect } from "react";
import { Button, Checkbox, TextField, Popover } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function filterData(data, search) {
  return data?.filter((item) => item?.display_label.toLowerCase().includes(search.toLowerCase()));
}

export const DndAutocomplete2 = ({ systemMandatoryTrue, allFields, savedPopupField_Ids, handleSave }) => {
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedField_Ids, setSelectedField_Ids] = useState([]);

  const fieldsObj = allFields?.reduce((acc, field) => {
    acc[field.id] = field;
    return acc;
  }, {});

  const selectedFields = selectedField_Ids?.map((id) => fieldsObj[id]);

  const remainingFields = allFields?.filter((field) => {
    return !selectedField_Ids.includes(field.id);
  });

  useEffect(() => {
    if (systemMandatoryTrue?.length > 0) {
      const temp = systemMandatoryTrue?.map((field) => field?.id);
      setSelectedField_Ids(temp);
    }
  }, [systemMandatoryTrue]);

  useEffect(() => {
    if (savedPopupField_Ids?.length > 0) {
      setSelectedField_Ids(savedPopupField_Ids);
    }
  }, [savedPopupField_Ids]);

  const draggedItemIndex = useRef(null);
  const hoveredOverItem = useRef(null);

  const handleDragStart = (index) => {
    draggedItemIndex.current = index;
  };

  const handleDragEnter = (hoverOverIndex) => {
    if (draggedItemIndex.current === null || hoverOverIndex === null) {
      return;
    }

    hoveredOverItem.current = hoverOverIndex;

    if (draggedItemIndex.current !== hoverOverIndex) {
      const tempIds = [...selectedField_Ids];
      const draggedItem = tempIds.splice(draggedItemIndex.current, 1)[0];
      tempIds.splice(hoverOverIndex, 0, draggedItem);
      draggedItemIndex.current = hoverOverIndex;
      setSelectedField_Ids(tempIds);
    }
  };

  const handleDragEnd = () => {
    draggedItemIndex.current = null;
    hoveredOverItem.current = null;
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        id="search-field-button"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        type="button"
        disableRipple
        fullWidth
        sx={(theme) => {
          return {
            color: theme.palette.text.secondary,
            textTransform: "capitalize",
            fontSize: "1rem",
            bgcolor: theme.palette.action.hover,
            justifyContent: "space-between",
            lineHeight: "normal",
          };
        }}
        endIcon={<ArrowDropDownIcon />}
        // disabled={!remainingFields || remainingFields?.length === 0}
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        Popup Field
      </Button>

      <Popover
        id={open ? "simple-popover" : undefined}
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setSelectedField_Ids(savedPopupField_Ids);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        aria-labelledby="search-field-button"
      >
        <TextField
          sx={{ p: ".25em" }}
          size="small"
          variant="standard"
          fullWidth
          placeholder="Search Field"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <ul
          style={{
            maxHeight: 300,
            overflowY: "auto",
            padding: 0,
            margin: 0,
          }}
        >
          {filterData(selectedFields, search)?.map((item, index) => {
            const { api_name } = item;
            return (
              <li
                key={api_name}
                style={{ padding: "1px 0", listStyle: "none" }}
                draggable
                onDragOver={(e) => e.preventDefault()}
                onDragStart={() => handleDragStart(index)}
                onDragEnter={() => handleDragEnter(index)}
                onDragEnd={handleDragEnd}
              >
                <Checkbox
                  id={api_name}
                  style={{ padding: 0 }}
                  checked={true}
                  disabled={item.system_mandatory}
                  onChange={(e) => {
                    if (e.target.checked) {
                      return;
                    }
                    setSelectedField_Ids((pre) => {
                      return pre?.filter((id) => id !== item.id);
                    });
                  }}
                />
                <label htmlFor={api_name} style={{ cursor: "pointer" }}>
                  {item?.display_label}
                </label>
              </li>
            );
          })}
          {filterData(remainingFields, search)?.map((item, index) => {
            const { api_name } = item;
            return (
              <li key={api_name} style={{ padding: "1px 0", listStyle: "none" }}>
                <Checkbox
                  id={api_name}
                  style={{ padding: 0 }}
                  onChange={(e) => {
                    if (!e.target.checked) {
                      return;
                    }
                    setSelectedField_Ids((pre) => {
                      return [...pre, item?.id];
                    });
                  }}
                />
                <label htmlFor={api_name} style={{ cursor: "pointer" }}>
                  {item?.display_label}
                </label>
              </li>
            );
          })}
        </ul>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: ".5em",
          }}
        >
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setAnchorEl(null);
            }}
            style={{ marginRight: 8 }}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              handleSave(selectedField_Ids?.map((id) => fieldsObj[id]));
              setAnchorEl(null);
            }}
          >
            OK
          </Button>
        </div>
      </Popover>
    </>
  );
};
